<div class="form-group row">
    <label class="col-md-2 col-form-label">Sample Condition</label>
    <div class="col-md-10">
        <active-vocab-select [(model)]="order.C_SampleCondition_key"
                             [vocabChoices]="sampleConditions"
                             [keyFormatter]="sampleConditionKeyFormatter"
                             [optionFormatter]="sampleConditionFormatter"
                             [nullable]="true"></active-vocab-select>
    </div>
</div>

<div class="form-group row">
    <label class="col-md-2 col-form-label">Sample Count</label>
    <div class="col-md-10">
        <input type="number"
               name="SampleCount"
               #name="ngModel"
               [(ngModel)]="order.SampleCount"
               class="form-control input-medium" />
    </div>
</div>

<div class="form-group row">
    <label class="col-md-2 col-form-label">Sample Type</label>
    <div class="col-md-10">
        <active-vocab-select [(model)]="order.C_SampleType_key"
                             [vocabChoices]="sampleTypes"
                             [keyFormatter]="sampleTypeKeyFormatter"
                             [optionFormatter]="sampleTypeFormatter"
                             [nullable]="false"
                             required="true"></active-vocab-select>
    </div>
</div>

<div class="form-group row">
    <label class="col-md-2 col-form-label">Accession ID</label>
    <div class="col-md-10">
        <input type="text"
               name="AccessionID"
               #name="ngModel"
               [(ngModel)]="order.AccessionID"
               class="form-control input-medium" />
    </div>
</div>

 <lots-table [pkName]="'C_Order_key'"
             [pkValue]="order.C_Order_key"
             [entity]="order"
             [readonly]="readonly"></lots-table>
